<angular-editor id="editor1" [(ngModel)]="content" [config]="config" (ngModelChange)="onContentChange()"></angular-editor>
<div *ngIf="errorMessage" class="errorTxt__custom" style="margin-top: 4px;">
    {{ errorMessage }}
</div>